var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { resolveJSONType } from '../registry/jsonResolvers';
import { componentToJSON } from '../components/helpers';
import { dashboardToJSON } from '../dashboard/helpers';
import { automotiveToJSON } from '../automotive/helpers';
import { diagramToJSON } from '../diagram/helpers';
var shapeFactories = {
    rect: function (p, app) { return app.rect(p); },
    circle: function (p, app) { return app.circle(p); },
    ellipse: function (p, app) { return app.ellipse(p); },
    line: function (p, app) { return app.line(p); },
    arc: function (p, app) { return app.arc(p); },
    polygon: function (p, app) { return app.polygon(p); },
    polyline: function (p, app) { return app.polyline(p); },
    path: function (p, app) { return app.path(p); },
    star: function (p, app) { return app.star(p); },
    roundedRect: function (p, app) { return app.roundedRect(p); },
    text: function (p, app) { return app.text(p); },
    image: function (p, app) { return app.image(p); },
    sprite: function (p, app) { return app.sprite(p); },
    group: function (p, app) { return app.group(p); },
    layer: function (p, app) { return app.layer(p); },
};
var customFactories = {};
export function registerJSONType(type, factory) {
    customFactories[type] = factory;
}
export function fromJSON(json, app) {
    var e_1, _a;
    var _b;
    var props = (_b = json.props) !== null && _b !== void 0 ? _b : {};
    if (json.id)
        props.id = json.id;
    var node;
    var customFactory = customFactories[json.type];
    if (customFactory) {
        node = customFactory(props, app);
    }
    else if (shapeFactories[json.type]) {
        node = shapeFactories[json.type](props, app);
    }
    else {
        var resolved = resolveJSONType(json.type, props, app);
        if (resolved) {
            node = resolved;
        }
        else if (json.type === 'dashboard' || json.children) {
            node = app.group(props);
        }
        else {
            node = app.group(props);
        }
    }
    if (json.children && 'add' in node) {
        try {
            for (var _c = __values(json.children), _d = _c.next(); !_d.done; _d = _c.next()) {
                var child = _d.value;
                node.add(fromJSON(child, app));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return node;
}
function isGroupLike(node) {
    return Array.isArray(node.children);
}
/** Plain group/layer props for authoring export (no runtime metadata dump). */
function serializeGroupShell(node) {
    var props = {
        x: node.x,
        y: node.y,
        rotation: node.rotation,
        scaleX: node.scaleX,
        scaleY: node.scaleY,
        opacity: node.opacity,
        visible: node.visible,
    };
    if (node.name)
        props.name = node.name;
    if (node.fill != null)
        props.fill = node.fill;
    if (node.stroke != null)
        props.stroke = node.stroke;
    if (typeof node.strokeWidth === 'number' && node.strokeWidth !== 0) {
        props.strokeWidth = node.strokeWidth;
    }
    if (node.listening === false)
        props.listening = false;
    if (node.cacheAsBitmap)
        props.cacheAsBitmap = true;
    var json = { type: node.type, props: props };
    if (node.id)
        json.id = node.id;
    return json;
}
var COMPACT_DEFAULTS = {
    x: 0,
    y: 0,
    rotation: 0,
    scaleX: 1,
    scaleY: 1,
    opacity: 1,
    visible: true,
    listening: true,
    cacheAsBitmap: false,
    disabled: false,
    paused: false,
    enabled: true,
};
function isPlainObject(v) {
    return !!v && typeof v === 'object' && !Array.isArray(v);
}
function compactValue(key, value) {
    if (value === undefined || value === null)
        return undefined;
    if (typeof value === 'function')
        return undefined;
    if (key === 'metadata')
        return undefined;
    if (Object.prototype.hasOwnProperty.call(COMPACT_DEFAULTS, key) && COMPACT_DEFAULTS[key] === value) {
        return undefined;
    }
    if (Array.isArray(value)) {
        if (value.length === 0)
            return undefined;
        return value;
    }
    if (isPlainObject(value)) {
        var nested = compactProps(value);
        return nested && Object.keys(nested).length > 0 ? nested : undefined;
    }
    return value;
}
function compactProps(props) {
    var e_2, _a;
    var out = {};
    try {
        for (var _b = __values(Object.entries(props)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), k = _d[0], v = _d[1];
            var next = compactValue(k, v);
            if (next !== undefined)
                out[k] = next;
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return out;
}
/** Strip defaults / non-JSON noise from a SceneJSON tree (does not mutate input). */
export function compactSceneJSON(json) {
    var _a;
    var out = { type: json.type };
    if (json.id)
        out.id = json.id;
    if (json.theme)
        out.theme = json.theme;
    if (json.props && typeof json.props === 'object') {
        var props = compactProps(json.props);
        if (Object.keys(props).length > 0)
            out.props = props;
    }
    if ((_a = json.children) === null || _a === void 0 ? void 0 : _a.length) {
        out.children = json.children.map(compactSceneJSON);
    }
    return out;
}
/**
 * Serialize a node for authoring / `loadJSON` round-trip.
 * UI, dashboard, automotive, and diagram roots stay opaque `{ type, props }` leaves.
 * Plain groups recurse with the same rules (fixes stage `exportJSON` expansion).
 */
export function toJSON(node, options) {
    var _a, _b, _c, _d;
    var json;
    if ((_a = node.metadata) === null || _a === void 0 ? void 0 : _a.componentType) {
        json = componentToJSON(node);
    }
    else if ((_b = node.metadata) === null || _b === void 0 ? void 0 : _b.widgetType) {
        json = dashboardToJSON(node);
    }
    else if ((_c = node.metadata) === null || _c === void 0 ? void 0 : _c.autoType) {
        json = automotiveToJSON(node);
    }
    else if ((_d = node.metadata) === null || _d === void 0 ? void 0 : _d.diagramType) {
        json = diagramToJSON(node);
    }
    else if (isGroupLike(node)) {
        json = serializeGroupShell(node);
        json.children = node.children.map(function (child) { return toJSON(child, options); });
    }
    else {
        json = node.toJSON();
    }
    return (options === null || options === void 0 ? void 0 : options.compact) ? compactSceneJSON(json) : json;
}
/**
 * True when a root `group` is only a bag of children (identity transform, no module type).
 * Used by `loadJSON` to place children on the stage instead of nesting an extra group.
 */
export function isHoistableRootGroup(node) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!isGroupLike(node) || node.type !== 'group')
        return false;
    if (((_a = node.metadata) === null || _a === void 0 ? void 0 : _a.componentType) ||
        ((_b = node.metadata) === null || _b === void 0 ? void 0 : _b.widgetType) ||
        ((_c = node.metadata) === null || _c === void 0 ? void 0 : _c.autoType) ||
        ((_d = node.metadata) === null || _d === void 0 ? void 0 : _d.diagramType)) {
        return false;
    }
    var rot = node.rotation || 0;
    var sx = (_e = node.scaleX) !== null && _e !== void 0 ? _e : 1;
    var sy = (_f = node.scaleY) !== null && _f !== void 0 ? _f : 1;
    var op = (_g = node.opacity) !== null && _g !== void 0 ? _g : 1;
    return ((node.x || 0) === 0 &&
        (node.y || 0) === 0 &&
        rot === 0 &&
        sx === 1 &&
        sy === 1 &&
        op === 1 &&
        node.visible !== false);
}
/** Authoring-shaped export of stage contents (not the stage node itself). */
export function exportStageJSON(stage, options) {
    var children = stage.children.map(function (child) { return toJSON(child, options); });
    var scene = { type: 'group', children: children };
    return (options === null || options === void 0 ? void 0 : options.compact) ? compactSceneJSON(scene) : scene;
}
